export const EMAIL_INPUT_NAME = 'user_email';

export const PHONE_INPUT_NAME = 'user_phone';

export const COUNTRY_CODE_INPUT_NAME = 'phone_country_code';

export const COUNTRY_CALLING_CODE_INPUT_NAME = 'phone_country_calling_code';
